import fun from "../../../util/util";
import myConst from "@/util/my-const";
import Axios from "../../../axios"
import myApi from "@/util/my-api";
import Router from "@/router"
import store from "../../../store"
export default {
    namespaced:true,
    state:{
        integrSysMenu:"", //综合系统的菜单
        leftMenuList:"",//左侧菜单
        topMenuSelectVal:"",//一级菜单默认选中
        twoMenuSelectVal:"", //二级菜单选中项
        threeMenuSelectVal:"", //三级菜单选中项
        statList:[], //权限电站列表
    },
    mutations:{

        //设置综合系统的菜单
        async setIntegrSysMenu(state,menu){
            state.integrSysMenu = menu
            state.statList = store.getters['integSysMenu/getStationList']
            // console.log(menu);
            // 针对页面刚进来的时候，默认选中第一个一级菜单,逻辑有点繁琐,后续待优化
            if(Array.isArray(state.integrSysMenu) &&  state.integrSysMenu.length > 0){
                state.topMenuSelectVal = menu[0].menuCode
                if(Array.isArray(state.integrSysMenu[0].children) && state.integrSysMenu[0].children.length > 0){
                    //筛选出生效的二级菜单
                    const enableMenu = state.integrSysMenu[0].children.filter(x=>{
                        return  x.enableSign ==  myConst.menuDefShow.yes
                    })
                    if(enableMenu.length > 0){
                        state.leftMenuList = enableMenu
                        const firstMenu = state.leftMenuList[0];
                        // 根据不同的菜单类型执行不同的操作
                        // console.log(firstMenu);
                        switch (firstMenu.menuType){
                            case myConst.menuType.menu:
                                // 如果是普通菜单，直接跳转路由
                                Router.push({ path: firstMenu.routerPath });
                                // 设置默认选中第一个菜单项的逻辑
                                state.twoMenuSelectVal = firstMenu.menuCode;
                                break;
                            case myConst.menuType.openPageMenu:
                                // 如果是打开新页面的菜单，尝试找到第一个普通菜单项或目录菜单项进行跳转，并且打开新页面
                                if(state.leftMenuList.length > 1){
                                    let hasRedirected = false; // 路由跳转标记
                                    for (let i = 1; i < state.leftMenuList.length; i++){
                                        const menu = state.leftMenuList[i];
                                        if (menu.menuType === myConst.menuType.menu) {
                                            // 设置默认选中第一个菜单项的逻辑
                                            state.twoMenuSelectVal = menu.menuCode;
                                            Router.push({ path: menu.routerPath });
                                            hasRedirected = true;  // 设置为已跳转
                                            break;
                                        }  else if (menu.menuType === myConst.menuType.directory && menu.children.length > 0) {
                                            state.leftMenuList[i].isSel = true;
                                            // 设置默认选中第一个菜单项的逻辑
                                            state.twoMenuSelectVal = menu.menuCode;
                                            const firstChild = menu.children.find(child => child.menuType === myConst.menuType.menu);
                                            if (firstChild) {
                                                state.threeMenuSelectVal = firstChild.menuCode;
                                                Router.push({ path: firstChild.routerPath });
                                                hasRedirected = true;  // 设置为已跳转
                                            }
                                            break;
                                        } 
                                    }
                                    // 如果没有跳转路由，则执行 store.commit
                                    if (!hasRedirected) {
                                        await store.commit('integSysMenu/getStatMenuRouter');
                                    }
                                } else {
                                    //如果没有电站菜单,则直接在该页面跳转当前路由
                                    if(state.statList.length > 0){
                                        await store.commit('integSysMenu/getStatMenuRouter')
                                    } else {
                                        Router.push({ path: firstMenu.routerPath });
                                    }
                                   
                                }
                                
                                // window.open(firstMenu.routerPath, "_blank");   
                                break;
                            case myConst.menuType.directory:
                                  // 如果是目录菜单，选中目录并尝试跳转到其第一个子菜单项的路径（如果该子菜单是普通菜单）
                                  if (firstMenu.children.length > 0) {
                                    state.leftMenuList[0].isSel = true;
                                    // // 设置默认选中第一个菜单项的逻辑
                                    state.twoMenuSelectVal = firstMenu.menuCode;
                                    const firstChild = firstMenu.children.find(child => child.menuType === myConst.menuType.menu);
                                    if (firstChild) {
                                        state.threeMenuSelectVal = firstChild.menuCode;
                                        Router.push({ path: firstChild.routerPath });
                                    }
                                  }
                                break;
                            default:
                                // 其他情况暂不处理
                                break;
                        }

                    }
                } else {
                    state.leftMenuList = [] //如果父子菜单底下没有子菜单,则清空
                    store.commit('integSysMenu/getStatMenuRouter')
                }
            }
            localStorage.setItem(myConst.keyIntegrSysMenuList, JSON.stringify(menu));
        },

        //设置一级菜单选中的值
        async setTopMenuSelVal(state,val){
            state.topMenuSelectVal = val
            //根据一级菜单选中的id加载左侧的二级菜单
            if(state.integrSysMenu){
                let arr = state.integrSysMenu.filter(item=>{
                    return item.menuCode == val
                })
                if(arr.length > 0 && Array.isArray(arr[0].children) && arr[0].children.length > 0){
                    //筛选出生效的二级菜单
                    let enableMenu = arr[0].children.filter(x=>{
                        return x.enableSign ==  myConst.menuDefShow.yes
                    })
                    if(enableMenu.length> 0 ){
                        state.leftMenuList = enableMenu
                        // state.twoMenuSelectVal = state.leftMenuList[0].menuCode //默认选中第一个
                        const firstMenu = state.leftMenuList[0];
                        // 设置默认选中第一个菜单项的逻辑
                      
                        if(firstMenu.menuType == myConst.menuType.openPageMenu){
                            if(state.leftMenuList.length > 1) {
                                let hasRedirected = false; // 路由跳转标记
                                for (let i = 1; i < state.leftMenuList.length; i++){
                                    const menu = state.leftMenuList[i];
                                    if (menu.menuType === myConst.menuType.menu) {
                                        state.twoMenuSelectVal = state.leftMenuList[i].menuCode; //默认选中第一个
                                        hasRedirected = true;  // 设置为已跳转
                                        break;
                                    }  else if (menu.menuType === myConst.menuType.directory && menu.children.length > 0) {
                                        state.twoMenuSelectVal = state.leftMenuList[i].menuCode;
                                        hasRedirected = true;  // 设置为已跳转
                                        break;
                                    }
                                }
                                // 如果没有跳转路由，则执行 store.commit
                                if (!hasRedirected) {
                                    await store.commit('integSysMenu/getStatMenuRouter');
                                }
                            } else {
                                //如果没有电站菜单,则直接在该页面跳转当前路由
                                if(state.statList.length > 0){
                                    await store.commit('integSysMenu/getStatMenuRouter')
                                }
                            }
                            
                        } else {
                            state.twoMenuSelectVal = firstMenu.menuCode; //默认选中第一个
                        }

                    }

                } else {
                    state.leftMenuList = [] //如果父子菜单底下没有子菜单,则清空
                    store.commit('integSysMenu/getStatMenuRouter')
                }
            }
        },

        //设置二级菜单选中项
        setTwoMenuSelVal(state,code){
            state.twoMenuSelectVal = code
        },

        //设置三级菜单选中项
        setThreeMenuSelectVal(state,code){
            state.threeMenuSelectVal = code
        },

        //设置电站菜单
        setStationList(state,list){
            state.statList = list
            localStorage.setItem(myConst.keyPerStationList, JSON.stringify(list));
        },

        //获取电站菜单别跳转路由
        getStatMenuRouter(state){
            // state.statList = store.getters['integSysMenu/getStationList']
            if(state.statList.length > 0){
                const staId = state.statList[0].id //选中第一个电站菜单
                // 根据电站获取该电站的私有菜单
                Axios.post(myApi.getStatAndMenu, { stationId: staId }).then(res=>{
                    if(res.data.code === myConst.code.success){
                        if (res.data.data.length > 0){
                            store.commit('statMenu/setStatName', res.data.data[0].stationName); //设置电站的名称
                            store.commit('integSysMenu/setTwoMenuSelVal', ""); //设置二级菜单选中值
                            store.commit('statMenu/setStatId', staId); //设置当前选中的电站
                            store.commit('statMenu/setStatMenuList', res.data.data); //设置电站的私有菜单
                            let staMenu = store.getters['statMenu/getStationMenu']
                            store.commit('statMenu/setStatMenuSelVal', staMenu[0].id); //设置私有电站菜单的选中值
                            store.commit('statMenu/setDevId', null); //设置当前选中的设备id
                            store.commit('statMenu/setDevType', null); //设置当前选中的设备类型
                            // 跳转当前私有菜单的第一个路由
                            Router.push({
                                path: res.data.data[0].routerPath
                            })
                        } else {
                            this.$message({
                                message: "该电站未配置菜单",
                                type: "info",
                            });
                        }
                    }
                })
            }
        },

        clearMenu(state){
            localStorage.removeItem(myConst.keyIntegrSysMenuList);
            localStorage.removeItem(myConst.keyPerStationList);
            state.integrSysMenu = "",
                state.leftMenuList = "",
                state.topMenuSelectVal = ""
            state.twoMenuSelectVal =""
            state.threeMenuSelectVal =""
            state.statList = []
        }

    },
    getters:{
        //获取综合系统的菜单数据
        getIntegrSysMenu(state){
            state.integrSysMenu = JSON.parse(localStorage.getItem(myConst.keyIntegrSysMenuList));
            return  state.integrSysMenu
        },

        //获取电站列表
        getStationList(state){
            state.statList = JSON.parse(localStorage.getItem(myConst.keyPerStationList));
            return state.statList
        },
    },

    actions:{
        // 获取权限电站列表
        async getPerStationList(context){
            try {
                let res = await Axios.get(myApi.getStationByPermission)
                if(res.data.code === myConst.code.success){
                    context.commit('setStationList',res.data.data)
                } else {
                    context.commit('setStationList',[])
                }
            } catch(error){
                context.commit('setStationList',[])
            }

        }
    }

}
